
















































































































































import { IResponseElement, Pagination, UniversidadFiltroModel, UniversidadInterface } from '@/models'
import store from '@/store'
import useAppConfig from '@core/@app-config/useAppConfig'
import useSweetAlert from '@core/plugins/sweetalert'
import {
  mdiCancel,
  mdiDotsVertical,
  mdiFilterVariantMinus,
  mdiPencilOutline,
  mdiPlus,
  mdiViewListOutline,
} from '@mdi/js'
import PaginationFooter from '@shared/components/PaginationFooter.vue'
// Shared
import PaginationSelect from '@shared/components/PaginationSelect.vue'
import { computed, defineComponent, onMounted, ref } from '@vue/composition-api'
// Components
import UniversidadFiltro from '../components/UniversidadFiltro.vue'
import UniversidadModal from '../components/UniversidadModal.vue'

export default defineComponent({
  components: {
    PaginationSelect,
    PaginationFooter,
    UniversidadFiltro,
    UniversidadModal,
  },
  setup() {
    const isFilterPanelActive = ref(false)
    const mostrarUniversidadModal = ref(false)
    const filtro = ref(new UniversidadFiltroModel())
    const pagination = ref(new Pagination())
    const { confirm, showMessage } = useSweetAlert()

    const { isLoading } = useAppConfig()

    onMounted(() => {
      obtenerUniversidades(filtro.value)
    })

    const obtenerUniversidades = async (filter: UniversidadFiltroModel) => {
      filtro.value = filter
      const params = { ...filtro.value, start: filtro.value.start - 1 }

      isLoading.value = true
      const { ok, response } = await store.dispatch('universidad/obtenerUniversidades', params)

      if (ok) {
        actualizarPaginacion(response)
      }

      isLoading.value = false
    }

    const actualizarPaginacion = (response: IResponseElement<UniversidadInterface>) => {
      pagination.value.setPagination(filtro.value.start, filtro.value.limit, response.totalCount)
      filtro.value.start = pagination.value.number
    }

    const editarUniversidad = (universidad: UniversidadInterface) => {
      store.commit('universidad/cargarUniversidad', universidad)
      mostrarUniversidadModal.value = true
    }

    const cambiarEstadoUniversidad = async (universidad: UniversidadInterface) => {
      const { value } = await confirm(`¿Está seguro de cambiar el estado de la universidad?`, 'success')

      if (value) {
        isLoading.value = true
        const { ok, response } = await store.dispatch('universidad/cambiarEstadoUniversidad', universidad.universidadId)

        if (ok) {
          showMessage('Éxito!', response.mensaje, 'success')
          obtenerUniversidades(filtro.value)
        }
        isLoading.value = false
      }
    }

    const universidadModalOnClose = (actualizar: boolean) => {
      mostrarUniversidadModal.value = false
      if (actualizar) {
        obtenerUniversidades(filtro.value)
      }
    }

    return {
      cambiarEstadoUniversidad,
      editarUniversidad,
      filtro,
      isFilterPanelActive,
      isLoading,
      mostrarUniversidadModal,
      obtenerUniversidades,
      pagination,
      universidades: computed<UniversidadInterface[]>(() => store.getters['universidad/universidades']),
      universidadModalOnClose,
      icons: {
        mdiCancel,
        mdiDotsVertical,
        mdiFilterVariantMinus,
        mdiPencilOutline,
        mdiPlus,
        mdiViewListOutline,
      },
    }
  },
})
